export function toQueryString (parameters = []) {
  let parts = []
  for (let key in parameters) {
    let value = parameters[key]
    if (typeof (value) !== 'undefined') {
      parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
    }
  }
  let qs = parts.join('&')
  return qs ? '?' + qs : ''
}

export function parseQueryString (search) {
  const query = {}
  if (typeof search === 'string') {
    const pairs = (search[0] === '?' ? search.substr(1) : search).split('&')
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=')
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
    }
  }
  return query
}



// WEBPACK FOOTER //
// ./src/utils/url.js